import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { News } from './pages/News';
import { History } from './pages/History';
import { Weather } from './pages/Weather';
import { Fixtures } from './pages/Fixtures';
import { Results } from './pages/Results';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { HelmetProvider } from 'react-helmet-async';
import { SingleNews } from './pages/SingleNews';

export function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/news" element={<News />} />
              <Route path="/history" element={<History />} />
              <Route path="/weather" element={<Weather />} />
              <Route path="/fixtures" element={<Fixtures />} />
              <Route path="/results" element={<Results />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/news/:slug" element={<SingleNews />} />
            </Routes>
          </main>
          <div className="mt-16">
            <Footer />
          </div>
        </div>
      </Router>
    </HelmetProvider>
  );
}
